export const inPolygon =  function (latLng, polygon) {
    return google.maps.geometry.poly.containsLocation(latLng, polygon);
}

export const inPolygons =  function (latLng, polygons) {
    for (const polygon of polygons) {
        if (inPolygon(latLng, polygon)) return true;
    }

    return false;
}
